import Vue from 'vue'

import App from './App.vue'
import router from './router'

import Vuetify from 'vuetify'
Vue.use(Vuetify)

import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS)

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

import store from './store/store'

import VueApollo from 'vue-apollo'

Vue.config.productionTip = false
Vue.use(VueApollo)

const client = new AWSAppSyncClient({
  url: appSyncConfig.graphqlEndpoint,
  region: appSyncConfig.region,
  auth: {
    type: appSyncConfig.authenticationType,
    apiKey: appSyncConfig.apiKey,
  }
}, {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    }
  }
})

import {storeClient} from './services/app-sync-service'
import AWSAppSyncClient from 'aws-appsync'
import appSyncConfig from './app-sync/AppSync'

client.hydrated().then(storeClient)

const appsyncProvider = new VueApollo({
  defaultClient: client
})

// Global components
// ...

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  provide: appsyncProvider.provide(),
  store
})



// WEBPACK FOOTER //
// ./src/main.js